import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import createQueryHook from '@segment/utils/createQueryHook';
import { createFsCacheProxy } from '@segment/utils/fsCache';
import { useStaticSiteBackend } from '@segment/contexts/staticSiteBackend';

var fetchAllEpisodes = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(client) {
    var enabled, fetchWithCache, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            enabled = Boolean(process.env.ENABLE_FS_CACHE);
            _context2.next = 3;
            return createFsCacheProxy(["goodDataBetterMarketing/episodes"], /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var rawResponse, description, nonEmptyData;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return client.get("/content/filter/podcastEpisodes");

                    case 2:
                      rawResponse = _context.sent;

                      if (rawResponse.items) {
                        _context.next = 7;
                        break;
                      }

                      description = rawResponse.toString();

                      if (typeof rawResponse === "object" && !Array.isArray(rawResponse) && rawResponse !== null) {
                        description = "Object with ".concat(Object.keys(rawResponse));
                      }

                      throw new Error("Got malformed response. Expected object with items property. Got ".concat(description));

                    case 7:
                      nonEmptyData = _objectSpread(_objectSpread({}, rawResponse), {}, {
                        items: rawResponse.items.filter(function (i) {
                          return i;
                        })
                      });
                      return _context.abrupt("return", nonEmptyData);

                    case 9:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            })), {
              enabled: enabled
            });

          case 3:
            fetchWithCache = _context2.sent;
            _context2.next = 6;
            return fetchWithCache();

          case 6:
            data = _context2.sent;
            return _context2.abrupt("return", data);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchAllEpisodes(_x) {
    return _ref.apply(this, arguments);
  };
}();

export var fetchAllEpisodesSlugs = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(client) {
    var allEpisodes;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return fetchAllEpisodes(client);

          case 2:
            allEpisodes = _context3.sent;
            return _context3.abrupt("return", allEpisodes === null || allEpisodes === void 0 ? void 0 : allEpisodes.items.map(function (i) {
              var _i$fields;

              return i === null || i === void 0 ? void 0 : (_i$fields = i.fields) === null || _i$fields === void 0 ? void 0 : _i$fields.slug;
            }));

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchAllEpisodesSlugs(_x2) {
    return _ref3.apply(this, arguments);
  };
}();
export var createEpisodeQuery = function createEpisodeQuery(client, episodeSlug) {
  return [["goodDataBetterMarketing/episodeQuery", episodeSlug], /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var _allEpisodes$items$fi, allEpisodes, episodeData;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return fetchAllEpisodes(client);

          case 3:
            allEpisodes = _context4.sent;
            episodeData = (_allEpisodes$items$fi = allEpisodes.items.find(function (s) {
              return s.fields.slug === episodeSlug;
            })) === null || _allEpisodes$items$fi === void 0 ? void 0 : _allEpisodes$items$fi.fields;

            if (episodeData) {
              _context4.next = 7;
              break;
            }

            throw new Error("Episode data is empty");

          case 7:
            return _context4.abrupt("return", episodeData);

          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4["catch"](0);
            console.error("Failed to find episode with ".concat(episodeSlug, ".\nUnderlying error: ").concat(_context4.t0));

          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 10]]);
  }))];
};
export var useEpisodeQuery = createQueryHook(createEpisodeQuery, useStaticSiteBackend, {
  staleTime: Infinity
});
export var fetchRecentEpisodesData = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(client) {
    var enabled, offset, limit, searchParams, cachedFetch;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            enabled = Boolean(process.env.ENABLE_FS_CACHE);
            offset = 0;
            limit = 4;
            searchParams = new URLSearchParams();
            searchParams.set("limit", limit.toString());
            searchParams.set("offset", offset.toString());
            _context5.next = 8;
            return createFsCacheProxy(["goodDataBetterMarketing/recentEpisodesDataQuery"], function () {
              return client.get("/content/filter/podcastEpisodes?".concat(searchParams.toString())).then(function (data) {
                return data.items.length ? data : null;
              });
            }, {
              enabled: enabled
            });

          case 8:
            cachedFetch = _context5.sent;
            return _context5.abrupt("return", cachedFetch());

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function fetchRecentEpisodesData(_x3) {
    return _ref5.apply(this, arguments);
  };
}();
export var createRecentEpisodesQuery = function createRecentEpisodesQuery(client, episodeSlug) {
  return [["goodDataBetterMarketing/recentEpisodesQuery", episodeSlug], /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var recentEpisodes, data;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return fetchRecentEpisodesData(client);

          case 3:
            recentEpisodes = _context6.sent;
            data = recentEpisodes === null || recentEpisodes === void 0 ? void 0 : recentEpisodes.items.filter(function (_ref7) {
              var fields = _ref7.fields;
              return fields.slug !== episodeSlug;
            }).slice(0, 3);

            if (data) {
              _context6.next = 7;
              break;
            }

            throw new Error("Recent episodes data is empty");

          case 7:
            return _context6.abrupt("return", data);

          case 10:
            _context6.prev = 10;
            _context6.t0 = _context6["catch"](0);
            console.error("Failed to load recent episodes.\nUnderlying error: ".concat(_context6.t0));

          case 13:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 10]]);
  }))];
};
export var useRecentEpisodeQuery = createQueryHook(createRecentEpisodesQuery, useStaticSiteBackend, {
  staleTime: Infinity
});